import { CommonModule } from '@angular/common';
import { Component, effect, EventEmitter, inject, Input, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { IonButton, IonImg } from '@ionic/angular/standalone';

import { ClientUserService } from '../../services/users/client/client.service';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-avatar-image',
    standalone: true,
    imports: [IonImg, IonButton, CommonModule, SvgIconComponent],
    templateUrl: './avatar-image.component.html',
    styleUrl: './avatar-image.component.css'
})
export class AvatarImageComponent {
    /* eslint-disable */
    clientUserService = inject(ClientUserService);

    @Input() image: SafeUrl | string | null | undefined = undefined;
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() customSize: number | undefined = undefined;
    @Input() customTextSize: number | undefined = undefined;
    @Input() name: string = '';
    @Input() defaultBorder: boolean = false;
    @Input() borderColor: string | undefined = undefined;
    @Input() initials: string = '';
    @Input() centered: boolean = false;
    @Input() avatarClasses: string = '';
    @Input() backgroundColor: string | undefined = undefined;
    @Input() initialsTextColor: string | undefined = undefined;
    @Input() badgeType: 'edit' | undefined = undefined;
    @Input() isClickable: boolean = false;
    @Input() setInitialsAsCurrentUser: boolean = false;

    @Output() onClick = new EventEmitter();

    loadingImg: boolean = false;
    imageLoadError: boolean = false;

    constructor() {
        effect(() => {
            if (this.setInitialsAsCurrentUser) {
                const user = this.clientUserService.user();
                this.initials = user ? (user?.first_name?.[0] || '') + (user?.last_name?.[0] || '') : '';
            } else if (this.name && !this.initials) {
                this.initials = this.name[0] || '';
            }
        });
    }

    onButtonClick() {
        this.onClick.emit();
    }

    imageError() {
        this.imageLoadError = true;
    }

    loadingImage() {
        this.loadingImg = true;
        this.imageLoadError = false;
    }

    loadedImage() {
        this.imageLoadError = false;
        this.loadingImg = false;
        console.log('loaded');
    }
}
